import React from "react";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Avatar from "@material-ui/core/Avatar";
import CardInfoField from "../../../ui/CardInfoField";
import FacilityImage from "./components/FacilityImage";
import { Typography } from "@material-ui/core";
import Button from "../../../ui/Button";
import Progress from "../../../ui/Progress";
import useResourceCard from "./useOrganizationCard";
import Chips from "../../../ui/Chips";
import src from "../../../images/nophoto_lg.png";

const drawerWidth = 280;

const useStyles = makeStyles(theme => ({
  title: {
    flexGrow: 1
  },
  curator: {
    display: "flex",
    flexDirection: "row",
    marginTop: 20
  },
  curatorPic: {
    marginRight: 17
  },
  avatarName: {
    fontSize: 14,
    color: "#000000"
  },
  avatarCaption: {
    marginTop: 10,
    fontSize: 10,
    textTransform: "uppercase",
    color: "#596E79"
  },
  hide: {
    display: "none"
  },
  demo: {
    marginTop: 16,
    display: "flex",
    "& img": {
      paddingRight: 10
    }
  },
  typo: {
    fontSize: 16,
    lineHeight: "24px"
  },
  more: {
    marginTop: 24,
    marginBottom: 80,
    display: "flex",
    justifyContent: "center"
  },
  cardTitle: {
    padding: "16px 0",
    borderBottom: "1px dashed #CACCD1",
    "& > div + div": {
      marginTop: 16
    }
  },
  cardTitleCenter: {
    padding: "16px 0",
    borderBottom: "1px dashed #CACCD1",
    textAlign: "center",
    "& > div + div": {
      marginTop: 16
    }
  },
  resourceType: {
    fontSize: 12,
    lineHeight: "16px",
    textAlign: "center",
    color: "#00334E"
  },
  font: {
    fontSize: 12,
    lineHeight: "16px",
    color: "#000000",
    marginTop: 8
  },
  progress: {
    display: "flex",
    justifyContent: "center"
  },
  drawerOpen: {
    width: drawerWidth,
    flexShrink: 0,
    zIndex: 1000,
    /*[theme.breakpoints.down("md")]: {
      position: "fixed"
    }*/
  },
  drawerClosed: {
    width: 0
  },
  drawerPaper: {
    width: drawerWidth,
    boxSizing: "border-box",
    top: 65
  },
  drawerPaperContent: {
    boxSizing: "border-box",
    padding: 20
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-start"
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    marginRight: -drawerWidth
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginRight: 0
  },
  iconsContainer: {
    bottom: "0",
    left: "0",
    padding: 10,
    display: "flex",
    position: "absolute",
    width: "100%",
    justifyContent: "space-between"
  },
  iconsItem: {
    display: "flex",
    flexDirection: "row"
  }
}));

const OrganizationDrawer = ({ open, organizationId, history, hideLink }) => {
  const classes = useStyles();
  const {
    getOrganizationCard,
    organizationCard,
    resetCard
  } = useResourceCard();
  const { card, worldSkills, specialities, curator } = organizationCard;

  React.useEffect(() => {
    resetCard();
    if (organizationId !== -1) {
      getOrganizationCard(organizationId);
    }
  }, [organizationId]);

  const onLinkClick = () => {
    history.push(`/work/app/organization/${card.info.id}`);
  };

  return (
    <Drawer
      className={open ? classes.drawerOpen : classes.drawerClosed}
      variant="persistent"
      anchor="right"
      open={open}
      classes={{
        paper: classes.drawerPaper
      }}
    >
      {card ? (
        <div className={classes.drawerPaperContent}>
          <FacilityImage fileId={card.info.logo} />
          <div className={classes.cardTitle}>
            <Typography className={classes.typo} align="center">
              {card.info.name}
            </Typography>
          </div>

{/*          <div className={classes.iconsContainer}>
            <div className={classes.iconsItem}>
              {card.info.roles && card.info.roles.map(role => (
                <SymbolIcon text={role.symbol} />
              ))}
            </div>
            <div className={classes.iconsItem}></div>
          </div>*/}
          <div className={classes.cardTitle}>
            <CardInfoField field="Город:" value={card.info.municipalName || "-"} />
            <CardInfoField field="Телефон:" value={card.info.phones || "-"} />
            <CardInfoField field="Email:" value={card.info.email} link />
            <CardInfoField field="Юр. адрес:" value={card.info.legalAddress} />
            {card.info.siteUrl && (
              <CardInfoField field="Сайт:" value={card.info.siteUrl} />
            )}
          </div>
          {(specialities.length > 0 || worldSkills.length > 0) && (
            <div className={classes.cardTitle}>
              <Typography variant="caption" color="textSecondary">
                Профессии и компетенции
              </Typography>
              <Chips specialities={specialities} worldSkills={worldSkills} largeWS={true} ellipsis={true}/>
            </div>
          )}
          {curator &&
        <div className={classes.cardTitle}>
            <Typography variant="caption" color="textSecondary">
              Куратор организации
            </Typography>
            <div className={classes.curator}>
              <div className={classes.curatorPic}>
                <Avatar src={curator.avatar ? `/work/api/file/${curator.avatar}` : src} />
              </div>
              <div>
                <div className={classes.avatarName}>{curator.name}</div>
                <div className={classes.avatarCaption}>{curator.post}</div>
              </div>
            </div>
          </div>
        }

          <div className={classes.more}>
            {!hideLink && <Button onClick={onLinkClick}>Подробнее</Button>}
          </div>
        </div>
      ) : (
        <div className={classes.progress}>
          <Progress />
        </div>
      )}
    </Drawer>
  );
};

export default withRouter(OrganizationDrawer);
